export default "__VITE_ASSET__a44031e5__"